import { render, staticRenderFns } from "./PlantingSocForm.new.vue?vue&type=template&id=f14035d4"
import script from "./PlantingSocForm.new.js?vue&type=script&lang=js&external"
export * from "./PlantingSocForm.new.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports